import { Box, CssBaseline } from "@mui/material";
import {
  AccountButton,
  AuthProvider,
  Navbar,
  type OidcUser,
} from "@ssf/auth-components";
import {
  AppWrapper,
  Footer,
  Page,
  queryClient,
  regTheme,
} from "@ssf/components";
import { setAuthorization as setMemdbAuthorization } from "@ssf/memdb-api";
import { QueryClientProvider } from "@tanstack/react-query";
import { Router } from "./components/index.js";
import { i18next } from "./lib/index.js";

const SIGNIN_REDIRECT_ARGS = { extraQueryParams: { createAccount: true } };
const onUser = (user: OidcUser | null | undefined) =>
  setMemdbAuthorization(user?.access_token);

export const App = () => (
  <AppWrapper env={import.meta.env} theme={regTheme} i18n={i18next}>
    <CssBaseline />
    <QueryClientProvider client={queryClient}>
      <AuthProvider signinRedirectArgs={SIGNIN_REDIRECT_ARGS} onUser={onUser}>
        <Page>
          <Navbar>
            <AccountButton />
          </Navbar>
          <Box sx={{ flex: "1 0 auto", position: "relative" }}>
            <Router />
          </Box>
          <Footer />
        </Page>
      </AuthProvider>
    </QueryClientProvider>
  </AppWrapper>
);
